import { match } from 'path-to-regexp';
import { useLocation } from 'react-router';

// Note changing this list during local dev will cause HMR to do crazy thing (you'll see errors in
// the console about missing nodes when removing child).
// TODO: After you change the list, reload the page!
const OLD_UI_ROUTES: string[] = [
  // remove pages here as they are migrated to the new UI
  '/sales/orders/:id',
  '/sales/channels/:id',
  '/automation/workflows/:id',
  '/integration/app/skubana/install',
  '/settings',
  '/settings/shipping',
  '/settings/shipping/profile/:id',
  '/shipping/carrier-services/:id',
  '/shipping/prices/:id',
  '/shipping/shipments',
];

const oldUiRouteMatcher = match(OLD_UI_ROUTES, { decode: decodeURIComponent });

export function useNewUiFeatureFlag() {
  const location = useLocation();
  return !oldUiRouteMatcher(location.pathname);
}
